import { render, staticRenderFns } from "./TaskFormFields.vue?vue&type=template&id=97fb8f16&scoped=true&"
import script from "./TaskFormFields.vue?vue&type=script&lang=js&"
export * from "./TaskFormFields.vue?vue&type=script&lang=js&"
import style0 from "./TaskFormFields.vue?vue&type=style&index=0&id=97fb8f16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97fb8f16",
  null
  
)

export default component.exports